module.exports = __webpack_public_path__ + "img/PMatrixTutorial.3ac42207.png";